var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
import { Keybinds } from 'common/core/keybinds/keybinds.service';
import { SelectAllEntries } from '../../state/actions/commands';
var EntriesContainerComponent = /** @class */ (function () {
    function EntriesContainerComponent(store, el, keybinds) {
        this.store = store;
        this.el = el;
        this.keybinds = keybinds;
        this.tabindex = 0;
    }
    EntriesContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.keybinds.listenOn(this.el.nativeElement);
        this.keybinds.addWithPreventDefault('ctrl+a', function () {
            _this.store.dispatch(new SelectAllEntries());
        });
    };
    __decorate([
        Select(DriveState.entries),
        __metadata("design:type", Observable)
    ], EntriesContainerComponent.prototype, "entries$", void 0);
    __decorate([
        Select(DriveState.entriesEmpty),
        __metadata("design:type", Observable)
    ], EntriesContainerComponent.prototype, "noEntries", void 0);
    __decorate([
        Select(DriveState.viewMode),
        __metadata("design:type", Observable)
    ], EntriesContainerComponent.prototype, "viewMode$", void 0);
    __decorate([
        Select(DriveState.activePageName),
        __metadata("design:type", Observable)
    ], EntriesContainerComponent.prototype, "activePageName$", void 0);
    return EntriesContainerComponent;
}());
export { EntriesContainerComponent };
